import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import HealthSafetyForm from "./HealthSafetyForm";

import { createHealthSafetyForm } from "../../../store/slices/healthSafetyFormSlice";

const AddHealthSafety = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    caseId: state?.caseId || null,
    patientId: state?.patientId || null,
    relation: "",
    named: "",
    acceptTerms: false,
    primaryCaregiverSignature: "",
    witnessSignature1: "",
    witnessSignature2: ""
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.acceptTerms) {
      Swal.fire("Incomplete", "Please accept the terms.", "warning");
      return;
    }

    // Convert camelCase to snake_case for backend
    const payload = {
      case_id: formData.caseId,
      patient_id: formData.patientId,
      relation: formData.relation,
      named: formData.named,
      accept_terms: formData.acceptTerms,
      primary_caregiver_signature: formData.primaryCaregiverSignature,
      witness_signature1: formData.witnessSignature1,
      witness_signature2: formData.witnessSignature2,
    };

    try {
      await dispatch(createHealthSafetyForm(payload)).unwrap();
      Swal.fire({
        title: "Saved!",
        text: "Health & Safety Form completed.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false
      });
      navigate("/home-visit/health-safety");
    } catch (error) {
      Swal.fire("Error!", "Failed to save form.", "error");
    }
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <HealthSafetyForm formData={formData} handleChange={handleChange} />
              <div className="col-12 d-flex justify-content-end mt-3">
                <div className="col-md-2 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary px-4 sticky-form-submit"
                  >
                    <i className="ri-save-2-line me-1"></i>
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddHealthSafety;
